import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["src"];
const _hoisted_2 = ["src"];
const _hoisted_3 = { class: "auth-shell__form-side" };
const _hoisted_4 = { class: "auth-shell__form" };
const _hoisted_5 = { class: "auth-shell__trust" };
import { ref } from "vue";
import PriorFooter from "@/components/PriorFooter.vue";
import { useMarkField } from "@/composables/useMarkField";
import markUrl from "@/assets/images/header-logo-white-icon.png";
import wordmarkUrl from "@/assets/images/header-logo-white.png";
export default /*@__PURE__*/ _defineComponent({
    __name: 'AuthShell',
    props: {
        width: { default: "narrow" }
    },
    setup(__props) {
        const panel = ref(null);
        const canvas = ref(null);
        const { markFieldUnavailable } = useMarkField(panel, canvas, markUrl);
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["auth-shell", `auth-shell--${__props.width}`])
            }, [
                _createElementVNode("div", {
                    ref_key: "panel",
                    ref: panel,
                    class: "auth-shell__panel"
                }, [
                    _createElementVNode("canvas", {
                        ref_key: "canvas",
                        ref: canvas,
                        class: "auth-shell__canvas",
                        "aria-hidden": "true"
                    }, null, 512),
                    (_unref(markFieldUnavailable))
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _unref(markUrl),
                            alt: "",
                            class: "auth-shell__fallback"
                        }, null, 8, _hoisted_1))
                        : _createCommentVNode("", true),
                    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "auth-shell__veil" }, null, -1)),
                    _createElementVNode("img", {
                        src: _unref(wordmarkUrl),
                        alt: "Lamar Health",
                        class: "auth-shell__wordmark"
                    }, null, 8, _hoisted_2),
                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "auth-shell__tagline" }, [
                        _createElementVNode("h2", null, [
                            _createTextVNode("Take care"),
                            _createElementVNode("br"),
                            _createTextVNode("of patients.")
                        ]),
                        _createElementVNode("p", null, "We'll take care of the rest.")
                    ], -1))
                ], 512),
                _createElementVNode("div", _hoisted_3, [
                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "auth-shell__spacer" }, null, -1)),
                    _createElementVNode("div", _hoisted_4, [
                        _renderSlot(_ctx.$slots, "default")
                    ]),
                    _createElementVNode("p", _hoisted_5, [
                        _createVNode(_component_v_icon, {
                            size: "16",
                            class: "auth-shell__trust-icon"
                        }, {
                            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                    _createTextVNode("mdi-shield-check-outline", -1)
                                ]))]),
                            _: 1
                        }),
                        _cache[3] || (_cache[3] = _createElementVNode("span", null, "This system contains protected health information. Access is monitored and logged.", -1)),
                        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "auth-shell__trust-badge" }, "SOC 2 · HIPAA", -1))
                    ]),
                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "auth-shell__spacer" }, null, -1)),
                    _createVNode(PriorFooter, { class: "auth-shell__footer" })
                ])
            ], 2));
        };
    }
});
